import styled from 'styled-components'

const H4 = styled.h4``

export default H4
